<script lang="ts">import { onMount } from 'svelte';
import { YinzCamCardsServiceElement } from "yinzcam-cards";
import { Readable } from "svelte/store";
import { findSourceStore } from "../../../utilities";
import { CardsDataSourceRegistration } from "../../../common/CardsDataSourceRegistration";
import HeadshotAnimAvatar from './HeadshotAnimAvatar.svelte';
export let element;
export let sources;
let srcStore;
let WinnerImages = [];
$: srcStore = findSourceStore($sources, 'YinzCamDropsServerCurrentDrop');
$: WinnerImages = ($srcStore === null || $srcStore === void 0 ? void 0 : $srcStore.WinnerImages) || [];
let pos = [];
onMount(() => {
    for (let i = 0; i < 20; i += 1) {
        pos[i] = {
            x: Math.round(Math.random() * 123456) % window.innerWidth,
            y: Math.round(Math.random() * 654987) % 300,
        };
    }
});
</script>

<div class="headshot-anim-card">
  {#each WinnerImages as item, i}
    <div class="avatar-wrapper" style={`
      left: ${pos[i] ? (pos[i].x || 0) : 0}px;
      top: ${pos[i] ? (pos[i].y || 0) : 0}px;
    `}>
      <HeadshotAnimAvatar url={item} />
    </div>
  {/each}
</div>

<style type="text/scss">*, *::after, *::before {
  box-sizing: border-box;
}

.headshot-anim-card {
  width: 100%;
  height: 100%;
  position: relative;
}

.avatar-wrapper {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
}</style>
